import React from 'react';
import {PageLoader} from "../../../../components/Loader";
import _ from "lodash";

import CardStatus from "../../../../components/timeline/components/CardStatus";
import ErrorNotFound from "../../../ErrorNotFound";
import {config} from "../../../../../config";
import Helmet from "react-helmet";
import {apiUrl} from "../../../../../libs/api";


class ProfileNotificationStatus extends React.Component {

    constructor(props) {
        super(props);
        let notificationId = _.get(this.props, 'match.params.notificationId');
        let userId = _.get(this.props, 'user._id');

        this.state = {
            error : false,
            loading : true,
            data : [],
        }

        if(userId && notificationId){
            //this.props.fetchUserStatus(userId, statusId);
            apiUrl.get(`users/${userId}/notifications/${notificationId}/status`).then(response => {
                if(response === null){
                    this.setState({error: true, loading : false})
                } else {
                    this.setState({data : response.data, loading : false});
                }
            }).catch(e => {
                this.setState({error: true, loading : false})
            })
        }

    }


    render() {
        if(this.state.error){
            return <ErrorNotFound />
        }

        return this.state.loading ? (
            <div className={"card "}>
                <PageLoader/>
            </div>
        ) : (
            <div className="card">
                <Helmet>
                    <title>{config.preTitle}Statut {config.postTitle}</title>
                    <meta name="robots" content="noindex" />
                </Helmet>
                <h2>Publication sur le mur</h2>
                {this.state.data.map(status =><div key={status._id}  className={"pb-16"}> <CardStatus parentId={status} createdAt={status.createdAt}/></div>)}

            </div>
        )
    }
}


export default ProfileNotificationStatus;
